var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab_bar_wrap"},_vm._l((_vm.items),function(t){return _c('div',{key:t.id,staticClass:"lable",class:{ on: t.selected },on:{"click":function($event){return _vm.tab(t)}}},[_vm._v("\n    "+_vm._s(t.name)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }